import { Screen } from '../../@types/types'
import { FlowScreen, FlowScreenElement } from '../../@types/flow-types'
import { SCREEN_OBJECT_NUMBERS, SCREEN_REALTOR_LEAD_ENGINE, SCREENS } from '../domain/wizardScreens'

export function getPreviousWizardScreens(screen: Screen, flowScreens: FlowScreenElement[]) {
  const screens = flowScreens.map((item) => ({ ...item.screen }))
  const index = screens.findIndex((item) => item.id === screen.id)
  return screens.slice(0, index)
}

export const getScreens = (flowScreens: FlowScreen[]): Screen[] => flowScreens.map((flowScreen) => flowScreen.screen)

export const getNavigationBarScreens = (flowScreens: FlowScreen[]): Screen[] => {
  const screenNamesToOmit: string[] = [SCREENS[SCREEN_REALTOR_LEAD_ENGINE].name, SCREENS[SCREEN_OBJECT_NUMBERS].name]
  return flowScreens
    .filter((flowScreen) => !screenNamesToOmit.includes(flowScreen.screen.name))
    .map((flowScreen) => flowScreen.screen)
}

export function getFlowScreens(flowScreens: FlowScreenElement[]) {
  return flowScreens.map((flowScreen) => ({ screen: flowScreen.screen }))
}
